import { GeoRecordMode, WebRecordingSettings } from '@fullstory/proto/fs/services/orgs';
import { timestamp } from '@fullstory/proto/google/protobuf';

export const GET_WEB_RECORDING_SETTINGS_RESPONSE: WebRecordingSettings = {
  recordingEnabled: true,
  consoleWatcherEnabled: true,
  ajaxWatcherEnabled: true,
  onlyRecordKnownDomains: true,
  domains: [],
  watches: [
    {
      namedElementId: 'watchedElement1',
      selector: '',
      label: '',
      notes: '',
      lastUpdated: '2023-04-10T18:13:26.136150Z' as timestamp,
    },
    {
      namedElementId: 'archivedWatchedElement1',
      selector: '',
      label: '',
      notes: '',
      lastUpdated: '2023-04-10T18:13:26.136150Z' as timestamp,
    },
  ],
  recordGeoMode: GeoRecordMode.GEO_ALL,
  recordGeoZones: [],
  blockedIps: [],
  blockedUas: [],
  blockedAppIds: [],
  resourceUploadingEnabled: true,
};
